import { Link } from '@nick-mazuk/ui/elements/link'
import { TextContent } from '@nick-mazuk/ui/elements/text-content'
import { YouTube } from '@nick-mazuk/ui/elements/video'
import { HeroSimple } from '@nick-mazuk/ui/marketing/layouts/heros/simple'
import { Layout } from 'components/layout'
import { Scripts } from 'components/scripts'
import type { GetStaticProps } from 'next'

import type { Script } from 'lib/sanity'
import { getJWLuaScripts } from 'lib/sanity'

export default function JWLua({ allScripts }: { allScripts: Script[] }): JSX.Element {
    const pageColor = 'highlight'

    return (
        <Layout title='JW Lua Scripts'>
            <div style={{ '--c-link': 'var(--c-highlight-default' } as React.CSSProperties}>
                <HeroSimple
                    title='Speed and power'
                    subtitle='JW Lua scripts that can supercharge your Finale workflow'
                    seoTitle='JW Lua scripts'
                    color={pageColor}
                />
                <Scripts scripts={allScripts} color={pageColor} />
                <section className='mt-24 wrapper'>
                    <TextContent>
                        <h2 className='text-center'>More resources</h2>
                        <h4>What is JW Lua?</h4>
                        <p>
                            JW Lua is a third-party plugin for Finale developed by Jari Williams.
                            You can find more about the plugin at{' '}
                            <Link href='http://jwmusic.nu/jwplugins/wiki/doku.php?id=jw_lua'>
                                his website
                            </Link>
                            .
                        </p>
                        <h4>Installing JW Lua scripts</h4>
                        <YouTube
                            id='EFGNuGCEIq4'
                            title='Getting started with Keyboard Maestro | Finale Superuser'
                        />
                        <h4>Quick disclaimer</h4>
                        <p>
                            These macros are not production quality. They may have bugs (though I do
                            try to get most out). If you have issues,{' '}
                            <Link href='/contact'>contact me</Link>. I may not have the time to fix
                            any bugs, but I can't fix them if I don't know about them!
                        </p>
                        <p>
                            Also, I'm not responsible for any adverse consequences. It's freeware
                            after all!
                        </p>
                        <h4>More JW Lua scripts</h4>
                        <ul>
                            <li>
                                <Link href='https://elbsound.studio/jw-lua-scripts.php'>
                                    Elbsound Studio
                                </Link>
                            </li>
                            <li>
                                <Link href='http://finale-logiciel-aide-gravure-musicale.eu/viewtopic.php?f=15&t=55#indexlua'>
                                    Chris's scripts
                                </Link>
                            </li>
                            <li>
                                <Link href='http://jwmusic.nu/jwplugins/wiki/doku.php?id=jwlua:quickscripts'>
                                    Jari Williams' smaller scripts
                                </Link>
                            </li>
                            <li>
                                <Link href='http://jwmusic.nu/jwplugins/wiki/doku.php?id=jwlua:fullscripts'>
                                    Jari Williams' larger scripts
                                </Link>
                            </li>
                        </ul>
                    </TextContent>
                </section>
            </div>
        </Layout>
    )
}

export const getStaticProps: GetStaticProps = async () => {
    const allScripts = await getJWLuaScripts()
    return {
        props: {
            allScripts: allScripts ?? null,
        },
    }
}
